/**
 * Cart icon header
 * If the component exists, it is assumed it contains a label element in it.
 */

/**
 * Services
 */
import axios from 'axios';
import globalEventsService from '../services/global-events.service';

/**
 * Compoment constants/vars
 */
const componentClass = 'component-cart-icon-header';
const labelHiddenClass = 'hidden';
let jqComponent;
let jqLabel;
let ajaxCartArticlesCountUrl;

/**
 * Init
 */
function init ()
{
    jqComponent = $('.'+componentClass);
    if (jqComponent.length > 0) {
        jqLabel = jqComponent.find('label');
        ajaxCartArticlesCountUrl = jqComponent.data('cart-articles-count-url');
        globalEventsService.addEventListener(globalEventsService.EVENT_CART_UPDATE, cartUpdateHandler);
        cartUpdateHandler();
    }
}

/**
 * Cart update handler
 * @param Event (not used)
 */
function cartUpdateHandler (event)
{
    axios.get(ajaxCartArticlesCountUrl)
        .then(response => {
            const articlesCount = response.data;
            jqLabel.html(articlesCount);
            if (articlesCount > 0) {
                jqLabel.removeClass('hidden');
            } else {
                jqLabel.addClass('hidden');
            }
        });
}

/**
 * Export default
 */
export default {
    init,
}
